const initialState = {
  loggedIn: false,
  loggingIn: false,
  loginError: false,
  userData: null,
  reflections: [],
  fetchingReflections: false,
  hasFetchedReflections: false,
  hasAccess: true
};

export default function user(state = initialState, action) {
  switch (action.type) {
    case 'LOGIN_BUSY':
    case 'LOGGING_IN':
      return {
        ...state,
        loggingIn: true
      };
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        loggingIn: false,
        loggedIn: true,
        userData: action.res,
        hasAccess: true
      };
    case 'LOGIN_ERROR':
      return {
        loggingIn: false,
        loginError: true,
        loggedIn: false,
        userData: null
      };
    case 'LOG_OUT':
      localStorage.clear();
      return initialState;
    case 'FORGOT':
    case 'NEW_PASSWORD':
      if (action.res.status !== 200) {
        return {
          ...state,
          loginError: true,
          loggingIn: false
        };
      }
      return {
        ...state,
        loggingIn: false
      };
    case 'FETCHING_REFLECTIONS':
      return {
        ...state,
        fetchingReflections: true
      };
    case 'RECEIVE_REFLECTIONS':
      return {
        ...state,
        fetchingReflections: false,
        reflections: action.reflections,
        hasFetchedReflections: true
      };
    case 'NO_ACCESS':
      return {
        ...state,
        hasAccess: false,
        loggingIn: false,
        loggedIn: false,
        loginError: false,
        userData: null
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/user.js